<app-popin (close)="cancel()" [show]="show">
  <div class="flex flex-col pr-4 pl-4 pb-4 mt-2 text-center">
    <p class="text-secondary text-xl font-bold mb-4">
      {{ 'confirm_bank_connection_tab_closing' | translate }}
    </p>
    <p class="text-secondary text-sm mb-7">
      {{ 'if_continue_you_will_be_redirected_to_main_tab' | translate }}
    </p>
    <div class="flex flex-row justify-center mb-2">
      <button
        (click)="continue()"
        class="flex-1 text-secondary rounded-full pr-8 pl-8 pt-2 pb-2 border-secondary border-2 font-bold mr-5"
      >
        {{ 'continue' | translate }}
      </button>
      <button
        (click)="cancel()"
        class="flex-1 text-secondary rounded-full pr-8 pl-8 pt-2 pb-2 bg-primary font-bold"
      >
        {{ 'cancel' | translate }}
      </button>
    </div>
  </div>
</app-popin>
